import Image from "next/image";
import SocialIcon from "./SocialIcons";
import type { Partner } from "@/data/partners";

interface PartnerRowProps {
  partner: Partner;
}

export default function PartnerRow({ partner }: PartnerRowProps) {
  return (
    <div className="flex items-center gap-4 py-4">
      <div className="w-16 h-16 shrink-0 rounded-md border flex items-center justify-center overflow-hidden bg-white">
        <Image
          src={partner.logo}
          alt={partner.name}
          width={48}
          height={48}
          className="object-contain"
        />
      </div>
      <div className="flex-1">
        <p className="font-semibold text-gray-900 leading-tight">
          {partner.name}
        </p>
        <p className="text-sm text-gray-500">{partner.org}</p>
        <div className="flex gap-4 mt-2">
          {Object.entries(partner.socials).map(([type, href]) => (
            <SocialIcon key={type} href={href} type={type} />
          ))}
        </div>
      </div>
    </div>
  );
}